/* unplugin-vue-components disabled */import { render } from "./BudgetItem.vue?vue&type=template&id=60428cff&scoped=true&ts=true"
import script from "./BudgetItem.vue?vue&type=script&lang=ts"
export * from "./BudgetItem.vue?vue&type=script&lang=ts"

import "./BudgetItem.vue?vue&type=style&index=0&id=60428cff&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60428cff"]])

export default __exports__